export const defaultAvatarUrl =
  'https://s3.eu-west-1.amazonaws.com/image.mpg/56b2b4d5-8f83-40a6-8147-c190ae5da861.jpg';

export const appRoutesToRedirect: Record<
  string,
  {screenName: string; path: string}
> = {
  CreateLeague: {
    screenName: 'CreateCompetition',
    path: '/modal/competition-create',
  },
  Dashboard: {
    screenName: 'Dashboard',
    path: '/',
  },
  JoinLeague: {
    screenName: 'JoinCompetition',
    path: '/modal/competition-join',
  },
  //TODO: waiting front app
  // FollowLeague: {
  //   screenName: 'FollowLeague',
  //   path: '/follow/league',
  // },
  // PlayerStatistics: {
  //   screenName: 'PlayerStatistics',
  //   path: '/player-statistics/:championshipId/:playerId/data',
  // },
  Matches: {
    screenName: 'Matches',
    path: '/matches?tab=live',
  },
  //TODO: waiting front app
  // MatchesResultsChampionship: {
  //   screenName: 'MatchesResultsChampionship',
  //   path: '/championship-match/:championshipId',
  // },
  ChampionshipMatchDetails: {
    screenName: 'ChampionshipMatchDetails',
    path: '/matchDetails/:matchId',
  },
  Shop: {
    screenName: 'Shop',
    path: '/(root)/(menu)/shop',
  },
  FAQ: {
    screenName: 'FAQ',
    path: '/(root)/(menu)/faq',
  },
  LeagueRules: {
    screenName: 'LeagueRules',
    path: '/(root)/(menu)/rules/league',
  },
  TournamentRules: {
    screenName: 'TournamentRules',
    path: '/(root)/(menu)/rules/tournament',
  },
  Tuto: {
    screenName: 'Tuto',
    path: '/(root)/(menu)/tuto',
  },
  //TODO: waiting front app
  // Algo: {
  //   screenName: 'Algo',
  //   path: '/algo/:tabIndex',
  // },
  UserSettings: {
    screenName: 'UserSettings',
    path: '/(root)/(menu)/settings',
  },
  //TODO: waiting front app
  // UserLeagues: {
  //   screenName: 'UserLeagues',
  //   path: '/user/leagues',
  // },
  // GDPR: {
  //   screenName: 'GDPR',
  //   path: '/gdpr',
  // },
  DataPool: {
    screenName: 'DataPool',
    path: '/data',
  },
};

export const avatrUrloptions = [
  {
    label: 'Défault',
    imageUrl: defaultAvatarUrl,
  },
  {
    label: 'Mode Expert',
    imageUrl:
      'https://s3.eu-west-1.amazonaws.com/image.mpg/ee195f5b-c006-4be5-bac0-fa272ff95009.png',
  },
  {
    label: 'Vip Pass',
    imageUrl:
      'https://s3.eu-west-1.amazonaws.com/image.mpg/fca2fe3e-1af0-4359-9d44-83a3e3682417.png',
  },
  {
    label: 'Brief',
    imageUrl:
      'https://s3.eu-west-1.amazonaws.com/image.mpg/9e377fed-a78d-4392-9e46-9fc32862244a.png',
  },
  {
    label: 'Live Rating',
    imageUrl:
      'https://s3.eu-west-1.amazonaws.com/image.mpg/125d8e44-71ed-4286-8c9a-9545b9f6662b.png',
  },
  {
    label: 'No Ads',
    imageUrl:
      'https://s3.eu-west-1.amazonaws.com/image.mpg/1d739156-1d56-4dc7-99fd-e9a03da5dd35.png',
  },
  {
    label: 'Head in the air',
    imageUrl:
      'https://s3.eu-west-1.amazonaws.com/image.mpg/58f1225c-940e-4d2b-b5a9-3d33860603ee.png',
  },
  {
    label: 'Remove Goal',
    imageUrl:
      'https://s3.eu-west-1.amazonaws.com/image.mpg/f0247cc8-c52b-4e63-8f93-c56de52c2e68.png',
  },
  {
    label: 'France',
    imageUrl: 'https://s3.eu-west-1.amazonaws.com/image.mpg/FR.png',
  },
  {
    label: 'Angleterre',
    imageUrl: 'https://s3.eu-west-1.amazonaws.com/image.mpg/GB-ENG.png',
  },
  {
    label: 'Espagne',
    imageUrl: 'https://s3.eu-west-1.amazonaws.com/image.mpg/ES.png',
  },
  {
    label: 'Ligue 2',
    imageUrl: 'https://s3.eu-west-1.amazonaws.com/image.mpg/L2.png',
  },
  {
    label: 'Italie',
    imageUrl: 'https://s3.eu-west-1.amazonaws.com/image.mpg/IT.png',
  },
  {
    label: 'LDC',
    imageUrl: 'https://s3.eu-west-1.amazonaws.com/image.mpg/EU.png',
  },
];



// WEBPACK FOOTER //
// ./src/components/NotificationEditor/components/NotificationEditorContent/constant.ts